import {useState} from 'preact/hooks'
import React from 'react'
import {Modal} from 'react-bootstrap'
import {Link, useNavigate} from 'react-router-dom'

const UseTemplateName = ({
  show,
  setOpen,
  campName,
  setCampName,
  setdata,
  data,
  userData,
  close,
}: any) => {
  const navigate = useNavigate()

  const handleClick = () => {
    setOpen()
    if (data == undefined) {
      navigate('/New-Template', {
        state: {
          data: {...userData?.data, ...campName},
          ourTemplate: true,
        },
      })
      setCampName({...campName, name: ''})
    } else {
      let template = {...data, ...campName, ...userData?.data, gotoNext: true}

      setdata({...data, ...template})
      close()
      setCampName({...campName, name: ''})
    }
  }
  return (
    <>
      <Modal
        id='kt_modal_create_app'
        tabIndex={-1}
        aria-hidden='true'
        dialogClassName='modal-dialog-centered modal-lg'
        show={show}
        onHide={setOpen}
      >
        <div className='modal-header'>
          <h4 style={{fontWeight: 'bold'}} className='modal-title' id='myModalLabel'>
            Name for Use Template
          </h4>
          <button
            type='button'
            className='close'
            data-dismiss='modal'
            onClick={setOpen}
            aria-hidden='true'
          >
            ×{' '}
          </button>
        </div>
        <div id='campModelErrorBar'></div>
        <div className='modal-body' style={{paddingTop: '0px'}}>
          <label>Name of new campaign</label>
          <input
            type='text'
            className='form-control bg-light border-0'
            placeholder='New Campagin'
            onChange={(e: any) => {
              setCampName({...campName, name: e?.target?.value})
            }}
          />
          <label>Subtitle</label>
          <input
            type='text'
            className='form-control bg-light border-0'
            placeholder='Subtitle'
            onChange={(e: any) => {
              setCampName({...campName, subTitle: e?.target?.value})
            }}
          />
        </div>
        <div className='mt-5'>
          <button
            className='btn btn-sm btn-light btn-primary me-2 w-100 mw-150px p-3 fw-500'
            onClick={handleClick}
            disabled={campName?.name == ''}
          >
            Use the Template
          </button>
        </div>
      </Modal>
    </>
  )
}

export default UseTemplateName
